// extracted by mini-css-extract-plugin
export default {"pagnationList":"pagnationComponet_pagnationList__hvBjJ","pageNum":"pagnationComponet_pageNum__hSkrO"};